import {Injectable} from '@angular/core';
import {HttpService} from "../../core/services/http.service";
import {Observable, of} from "rxjs";
import {ConfirmationModel} from "../../core/models/confirmation.model";
import {CommentModel} from "../../core/models/comment.model";
import {environment} from '../../../environments/environment';
import {TimeSlotsModel} from "../../core/models/time-slots.model";
import {AppointmentModel} from "../../core/models/appointment.model";
import {TimeSlotModel} from "../../core/models/time-slot.model";
import {map} from "rxjs/operators";
import {FactoryIdToCountryMapper} from "./factory-id-to-country-mapper";

const API_URL = environment.apiUrl;

@Injectable()
export class AppointmentService {

  constructor(private httpService: HttpService, private factoryIdToCountryMapper: FactoryIdToCountryMapper) {
  }

  getAppointment(id: string, factoryId: string, language: string): Observable<AppointmentModel> {
    return this.httpService.get<any>(API_URL + `/appointments/${id}`).pipe(
      map((appointment: AppointmentModel) => {
        appointment.factoryId = factoryId;
        appointment.language = language.toLowerCase();
        appointment.country = this.factoryIdToCountryMapper.getCountry(factoryId) || 'DE';
        return appointment;
      })
    );
  }

  confirmProposal(id: string, accept: boolean, isTestRun: boolean): Observable<any> {
    if (isTestRun) {
      return of(true);
    }
    const confirmation: ConfirmationModel = {
      id: id,
      accept: accept
    };
    return this.httpService.post<any>(API_URL + `/confirm/${id}`, confirmation);
  }

  addComment(appointment: AppointmentModel, comment: CommentModel, isTestRun?: boolean): Observable<any> {
    // fix desiredDate timezone issue
    if (comment.desiredDate) {
      comment.desiredDate = new Date(comment.desiredDate.getTime() - (comment.desiredDate.getTimezoneOffset() * 60000));
    }
    if (isTestRun) {
      return of(true);
    }
    return this.httpService.post<any>(API_URL + `/appointments/${appointment.id}/comment?country=${appointment.country}&language=${appointment.language}`, comment);
  }

  getTimeSlots(id: string): Observable<TimeSlotsModel> {
    return this.httpService.get<any>(API_URL + `/time-slots/${id}`);
  }

  bookTimeSlot(id: string, timeSlot: TimeSlotModel, isTestRun?: boolean): Observable<any> {
    if (isTestRun) {
      return of(true);
    }
    return this.httpService.post<any>(API_URL + `/time-slots/${id}/book`, timeSlot);
  }

  addToCalendar(id: string, subject: string, timezone: string) {
    window.location.href = API_URL + '/i-cal/' + id + '.ics'
      + '?subject=' + encodeURIComponent(subject) + '&timezone=' + encodeURIComponent(timezone);
  }

  generateInvitationLink(id: string, factoryId: string): Observable<any> {
    return this.httpService.get<any>(API_URL + `/business-partner-invitation/${id}?factoryId=${factoryId}`);
  }

}
